import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/page/HomePage'
import MenuPage from '@/page/MenuPage'
import CategoryPage from '@/page/CategoryPage.vue'
import AdminPage from '@/page/AdminPage.vue'
import LoginPage from '@/page/LoginPage.vue'
import DailyMenuPage from '@/page/DailyMenuPage.vue'

export function isAuthenticated() {
  const token = localStorage.getItem('saporimiei-admin-token');  
  return !!token;
}

const routes = [
  {
    path: '/',
    name: 'homepage',
    component: HomePage
  },
  {
    path: '/menu',
    name: 'MenuPage',
    component: MenuPage
  },
  {
    path: '/category/:title',
    name: 'CategoryPage',
    component: CategoryPage,
    props: true,
  },
  {
    path: '/admin',
    name: 'AdminPage',
    component: AdminPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/dailyMenu',
    name: 'DailyMenuPage',
    component: DailyMenuPage
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});


router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isAuthenticated()) {
    next('/login');
  } else {
    next();
  }
});


export default router;
